module.exports = __webpack_public_path__ + "static/img/google-play-badge-es.4efc149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google-play-badge-es.png
// module id = r9fk
// module chunks = 1